<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">KMT country form content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.locator_title" />
        </div>
        <div class="field-sec">
          <label>Search placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.locator_search_field" />
        </div>
        <div class="field-sec">
          <label>Show all studios text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.show_all_studios" />
        </div>
        <div class="field-sec">
          <label>Studios page link:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.show_all_studios_link" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="locator-container">
        <div class="locator-content-container">
          <div class="locator-left-sec">
            <h2 class="locator-title" id="locator_title">{{ fit20.blockToEdit.locator_title }}</h2>
            <div class="locator-search-section">
              <div class="locator-search-box">
                <input id="search_field" class="locator-search-field" type="search"
                  :placeholder="fit20.blockToEdit.locator_search_field" />
                <i class="fa fa-fw fa-search" onclick="" style="font-size: 20px"></i>
              </div>
            </div>
            <div class="show-all-studios-div">
              <a class="show-all-studios" id="show_all_studios">{{ fit20.blockToEdit.show_all_studios }}</a>
            </div>
          </div>
          <div class="address-container">
            <div id="locator_address">
              <a class="address-item" href="#">
                <div>
                  <img loading="lazy" src="https://www.fit20.com/files/locator/img/UK/placeholder.jpg" alt="" />
                  <div class="address-info-text not-fixed">
                    <div class="address-studio-name">fit20 example 1</div>
                    <div class="studio-info stronger">address 1<br />
                      post Code 1<br />
                      000000000
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'LocatorWithoutMap',
  props: ["fit20", "saveBlock", "cancelEditing"],
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.locator-container {
  background-color: #009fe31f;
  padding-top: 30px;
}

.locator-content-container {
  display: flex !important;
  flex-wrap: wrap;
  max-width: 1500px;
  margin: 0 auto;
}

.locator-left-sec {
  width: 40% !important;
  margin: auto;
  text-align: center;
}

.locator-left-sec-with-map {
  width: 45% !important;
}

#map {
  height: 500px;
}

#locator_address {
  display: flex !important;
  flex-wrap: wrap !important;
  width: 100%;
}

.address-container {
  width: 50% !important;
  margin: 0 auto;
  height: 560px;
  overflow-y: scroll;
  margin-top: 30px;
  margin-bottom: 30px;
  max-width: 650px !important;
}

.locator-title,
.address-studio-name {
  font-family: 'VAG Rounded Std light', Verdana, Tahoma, sans-serif !important;
}

.locator-search-btn,
.show-all-studios,
.address-item-btn {
  font-family: 'VAG Rounded Std light light', Verdana, Tahoma, sans-serif !important;
}

.address-container img {
  width: 100% !important;
  height: 155px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.locator-title {
  text-align: center !important;
  color: #009df4 !important;
}

.locator-search-section {
  max-width: 400px;
  margin: 0 auto;
  margin-top: 30px;
  background-color: white;
  border-radius: 30px;
  height: 30px;
}

.locator-search-section-with-map {
  width: 100%;
}

.locator-search-box {
  background-color: #ffffff !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border: solid 1px #494b5326 !important;
  border-radius: 30px;
  height: 30px;
}

.locator-search-field {
  width: 90% !important;
  font-size: 15px !important;
  border: none !important;
  padding: 15px 0 15px 10px !important;
  background-color: transparent !important;
  color: #494b53 !important;
  outline: none !important;
  border-radius: 30px;
  background-color: white;
}

.locator-search-box i {
  color: #009df4 !important;
  padding-right: 10px !important;
  cursor: pointer;
}

.locator-search-section select {
  width: 20% !important;
  text-align: center !important;
  font-size: 15px !important;
}

.locator-search-section select,
.locator-search-section .locator-search-btn {
  color: #494b53 !important;
  outline: none !important;
  border: none !important;
  margin-left: 5px !important;
}

.locator-search-section .locator-search-btn {
  background-color: #009fe3 !important;
  color: white !important;
  font-size: 18px !important;
  padding: 0 15px !important;
  width: auto !important;
}

.show-all-studios-div {
  margin-top: 30px;
}

a.show-all-studios {
  text-align: center !important;
  padding: 8px 15px !important;
  color: #009df4 !important;
  background-color: white;
  font-size: 14px !important;
  border: solid 1px #009df4;
  border-radius: 20px;
  transition: color 0.5s, background-color 0.5s;
}

.locator-left-sec a:link,
.locator-left-sec a:active,
.locator-left-sec a:visited {
  color: #009df4 !important;
  background-color: white;
  text-decoration: none !important;
}

.locator-left-sec a:hover {
  color: white !important;
  background-color: #009fe3;
  text-decoration: none !important;
}

.address-item {
  width: calc(100% / 2 - 30px) !important;
  text-align: center;
  border-radius: 10px;
  background-color: white;
  margin: 0px 25px 25px 0px;
  display: block;
  max-width: 265px;
  max-height: 300px;
  min-height: 250px;
}

.address-container::-webkit-scrollbar {
  width: 10px;
}

.address-container::-webkit-scrollbar-track {
  background: transparent !important;
  border-radius: 20px;
  box-shadow: inset 7px 0px 0px #0000002b;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}

.address-container::-webkit-scrollbar-thumb {
  background-color: #92d400;
  border-radius: 20px;
  border: 3px solid transparent;
  background-clip: padding-box;
}

.address-item:hover {
  box-shadow: 0 0 10px 0 gray !important;
}

.address-studio-name {
  font-size: 20px !important;
  color: #92d400;
}

.address-info-text {
  padding: 10px !important;
  font-size: 12px !important;
}

body div.not-fixed div.studio-info.stronger {
  font-size: 12px !important;
  color: #616365 !important;
  line-height: normal !important;
}

.address-item-btn {
  background-color: #009fe3 !important;
  text-align: center !important;
  padding: 10px 5px !important;
  position: absolute !important;
  width: 100% !important;
  display: block !important;
  z-index: 1 !important;
  margin: 0 auto !important;
  bottom: -40px !important;
}

.address-container a:link,
.address-container a:active,
.address-container a:visited,
.address-container a:hover {
  color: rgb(105, 105, 105) !important;
  text-decoration: none !important;
}

.address-item-btn:after {
  transition: all 0.5s !important;
  content: '' !important;
  background: #92d400 !important;
  width: 0% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  z-index: -1 !important;
}

.distance {
  text-align: right !important;
  padding: 3px 0 !important;
}

.span-distance {
  border: 1px solid !important;
  padding: 3px 6px !important;
}

@media only screen and (max-width: 1180px) {
  .address-container {
    height: 540px;
  }
}

@media only screen and (max-width: 850px) {
  .address-container {
    width: 60% !important;
  }

  .address-container-with-map {
    width: 50% !important;
  }

  .locator-title {
    font-size: 25px !important;
  }
}

@media only screen and (max-width: 650px) {

  .locator-left-sec,
  .address-container {
    width: 100% !important;
  }

  .locator-content-container:nth-child(1) {
    order: 1;
  }

  .locator-left-sec-with-map:nth-child(2) {
    order: 3;
  }

  .locator-content-container:nth-child(3) {
    order: 2;
  }

  .locator-container {
    padding-left: 20px;
  }

  .address-container {
    height: 300px;
  }

  .address-item {
    width: calc(85% - 20px) !important;
    margin: 6px auto;
  }

  .locator-left-sec-with-map {
    width: 100% !important;
  }

  #map {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 90% !important;
    height: 350px;
  }

  .locator-container-with-map {
    padding-left: 20px;
  }

  .address-container-with-map {
    width: 90% !important;
  }

  .address-container-with-map {
    height: 265px;
  }

  .address-item-with-map {
    width: calc(100% / 2 - 20px) !important;
    margin: 6px auto;
  }

  .locator-title {
    font-size: 20px !important;
  }
}
</style>
